// @flow
export const CompanyTypes = [
  { value: "DISTRIBUTER", label: "Distributer" }, 
  { value: "RESELLER", label: "Reseller" },
  { value: "ENDUSER", label: "End User" },
  { value: "TOPLEVEL", label: "Imagus Admin" }
];